import { LanguagesType } from './types';

export const DEFAULT_LANGUAGE: LanguagesType = 'pt';
